import type { FaireProductEntity } from "../../entity_types/product";

export const p_txfqaebg9h: FaireProductEntity = {
  token: "p_txfqaebg9h",
  type: "product",
  name: "Soft Chunky Abstract/Geometric Lines Fleece Scarf (8 colors)",
  brandToken: "b_jcn5s8r6ur",
  brandName: "Adorro",
  imageUrl:
    "https://cdn.faire.com/fastly/9fd3b4325614f06573a2a590278153e70128b1b8f2d652392a9d8d2b04a01de7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4b640822a8496e42a26745c244167af5d7852eff1ce450c1219c9a4efc4971f0.jpeg",
    "https://cdn.faire.com/fastly/89f605b0bd3a7cc1df666709c69e89e29cb7920ee7e552b86eaa5d448c1b0b9f.jpeg",
    "https://cdn.faire.com/fastly/0af89457166b417c8675b56da5b64d4a9d2b93131aeb89fee5f305028411eb73.jpeg",
    "https://cdn.faire.com/fastly/8605348d844d6a4edd17495848a8d8fb7c6cd23aa02e9165539cde258999d780.jpeg",
    "https://cdn.faire.com/fastly/94be07f178dcd4a74ee947e18ffd31a1fdfd5e11b468a4cf228b3eb6c9f52592.jpeg",
    "https://cdn.faire.com/fastly/9f0a21ed64a1bfc93a7eec4bbb3c4aaea54f70296163a3339c4f2617026095a6.jpeg",
    "https://cdn.faire.com/fastly/cfb221e46a406da2532a1b2d98ee0f306d7aa60569879e07290312e5b5684726.jpeg",
    "https://cdn.faire.com/fastly/4398f07f65eaace6f0851e03fde6f2d545e90fe5661808f530d9a0f6c72f7608.jpeg",
    "https://cdn.faire.com/fastly/cf9731e7f8eb7f979f41f957f5b664a1a3e19f4435300d4a77fc82b0c7545f45.jpeg",
    "https://cdn.faire.com/fastly/789872306b1923e7adde956398337047a27de90f5e45bc9a9cc133c4c426dc3d.jpeg",
    "https://cdn.faire.com/fastly/caa9595bb60657af8ca86f0b2cd5484cdc1e8f33c3bfebf4ea89a33a209ce9c3.jpeg",
    "https://cdn.faire.com/fastly/2cec1f90d059e689caa32ae767fdff4a51d6affc420bdd415b3ab3bd92e26e2e.jpeg",
  ],
  priceDollars: 15,
  description:
    'Soft Chunky Abstract/Geometric Lines Fleece Scarf \nSuper soft and super fuzzy in vibrant print colors, this brushed fleece scarf is like a hug you can wear. \n\nMaterial: 100% Acrylic\nWeight: 10.5 ounces \nsize: 15.7" W x 72.8"L\n\n\n',
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:38.640Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
